var React = require('react');

function AccountCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 6c3.31 0 6 2.69 6 6 0 3.32-2.69 6-6 6s-6-2.68-6-6c0-3.31 2.69-6 6-6zm0 28.4c-5.01 0-9.41-2.56-12-6.44.05-3.97 8.01-6.16 12-6.16s11.94 2.19 12 6.16c-2.59 3.88-6.99 6.44-12 6.44z"}));
}

AccountCircle.displayName = "AccountCircle";

AccountCircle.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = AccountCircle;

AccountCircle.default = AccountCircle;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/account_circle.svg